import { Controller } from '@hotwired/stimulus'

// Mark read and Mark all as read on the Requests inbox update the list in place, so nothing jumps.
// Opening a row marks it read through that row's own Mark read form, so the rail badge follows.
export default class extends Controller {
  static targets = ['item', 'readAll', 'markRead']

  open(event) {
    const form = this.markReadTargets.find((target) => event.target.closest('.ef-inbox__item').contains(target))
    if (form) form.requestSubmit()
  }

  read(event) {
    this.markRead(event.target.closest('.ef-inbox__item'))
    // Another page of this list may still hold unread requests, so Mark all stays while there is one.
    if (!this.element.querySelector('.ef-inbox [data-inbox-unread], .pagination')) this.removeReadAll()
    this.showCount(event.detail[0].unread)
  }

  readAll(event) {
    this.itemTargets.forEach((item) => this.markRead(item))
    this.removeReadAll()
    this.showCount(event.detail[0].unread)
  }

  markRead(item) {
    item.classList.remove('ef-inbox__item--new')
    item.querySelectorAll('[data-inbox-unread]').forEach((node) => node.remove())
  }

  removeReadAll() {
    if (this.hasReadAllTarget) this.readAllTarget.remove()
  }

  // The rail's badge counts every form, so it takes the server's number rather than this page's rows.
  showCount(unread) {
    document.querySelectorAll('.settings-rail__link[aria-current="page"] .settings-rail__count').forEach((badge) => {
      if (unread > 0) badge.firstChild.textContent = unread
      else badge.remove()
    })
  }
}
